import type { BaseRecommendationSchema } from '~/types/schema';
import type { NomadDB } from '~/db/NomadDB';
import { getServices } from '~/db/services';

export const cleanRecommendationItemsSegmented = async (
  db: NomadDB,
  recommendedItems: BaseRecommendationSchema[],
  segementedIds: string[]
): Promise<BaseRecommendationSchema[]> => {
  const { categoriesService, exercisesService, postsService } = getServices(db);
  const ids = recommendedItems.reduce(
    (acc, item) => {
      if (segementedIds.includes(item.libraryBookId)) {
        switch (item.type) {
          case 'exercise':
            acc.exerciseIdsAndLibraryBookIds.push([
              item.id,
              item.libraryBookId,
            ]);
            break;
          case 'post':
            acc.postIdsAndLibraryBookIds.push([item.id, item.libraryBookId]);
            break;
        }
        if (item.rootSlug) {
          acc.categorySlugsAndLibraryBookIds.push([
            item.rootSlug,
            item.libraryBookId,
          ]);
        }
      }
      return acc;
    },
    {
      exerciseIdsAndLibraryBookIds: [],
      postIdsAndLibraryBookIds: [],
      categorySlugsAndLibraryBookIds: [],
    }
  );

  const posts = new Set(
    (
      await postsService.findByIdsAndLibraryBookIds(
        ids.postIdsAndLibraryBookIds
      )
    ).map((item) => `${item.libraryBookId}-${item.id}`)
  );

  const exercises = new Set(
    (
      await exercisesService.findByIdsAndLibraryBookIds(
        ids.exerciseIdsAndLibraryBookIds
      )
    ).map((item) => `${item.libraryBookId}-${item.id}`)
  );

  const categories = new Set(
    (
      await categoriesService.findBySlugsAndLibraryBookIds(
        ids.categorySlugsAndLibraryBookIds.filter(
          (item) => item[0] != null && item[1] != null
        )
      )
    ).map((item) => `${item.libraryBookId}-${item.slug}`)
  );

  const cleanedRecommendedItems = recommendedItems.reduce<
    BaseRecommendationSchema[]
  >((acc, item) => {
    if (segementedIds.includes(item.libraryBookId)) {
      if (item.type === 'exercise') {
        if (
          exercises.has(`${item.libraryBookId}-${item.id}`) &&
          categories.has(`${item.libraryBookId}-${item.rootSlug}`)
        ) {
          acc.push(item);
        }
      } else if (
        posts.has(`${item.libraryBookId}-${item.id}`) &&
        categories.has(`${item.libraryBookId}-${item.rootSlug}`)
      ) {
        acc.push(item);
      }
    } else {
      acc.push(item);
    }
    return acc;
  }, []);
  return cleanedRecommendedItems;
};
